import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from './ConfirmDialog';

interface PageClosingDialogProps {
  open: boolean;
  content: React.ReactNode;
  onClose: () => void;
  onContinue: () => void;
  title?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
}

const GeneralDialog = (props: PageClosingDialogProps) => {
  const { t } = useTranslation();

  const onConfirmFinishRental = () => {
    props.onContinue();
    props.onClose();
  };

  return (
    <ConfirmDialog
      open={props.open}
      title={props.title || t('use_order.closing_dialog.title')}
      content={props.content}
      cancelText={props.cancelButtonText || t('use_order.closing_dialog.cancel_button')}
      confirmText={props.confirmButtonText || t('use_order.closing_dialog.confirm_button')}
      onClose={props.onClose}
      onConfirm={onConfirmFinishRental}
    />
  );
};

export default GeneralDialog;
